(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["home-video-tile"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mmVideoInlineBound) return;
    window.__mmVideoInlineBound = true;

    function bindVideoEvents(video) {
      if (video.__mmBound) return;
      video.__mmBound = true;
      var tile = video.closest('[data-mm-video-inline]');
      if (!tile) return;
      video.addEventListener('play', function () { tile.classList.add('is-playing'); });
      video.addEventListener('pause', function () { tile.classList.remove('is-playing'); });
      video.addEventListener('ended', function () { tile.classList.remove('is-playing'); });
    }
    document.querySelectorAll('[data-mm-video-inline] video').forEach(bindVideoEvents);

    document.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-mm-video-inline]');
      if (!tile) return;
      var video = tile.querySelector('video');
      if (!video) return;
      e.preventDefault();
      bindVideoEvents(video);
      if (video.paused) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
    });

    // Warm-up (2026-08-16): the tiles ship preload="none" so page load stays
    // light, which used to mean the first tap started the download from zero.
    // First hover/touch bumps the inline element to metadata (moov atom only);
    // pointerdown/touchstart upgrades to full buffering — the shopper is
    // committing, so the fetch runs during the tap. No new elements, no cost
    // until a shopper actually reaches for a tile.
    function warmTile(tile, level) {
      var video = tile.querySelector('video');
      if (!video) return;
      if (level === 'auto') {
        if (video.preload !== 'auto') video.preload = 'auto';
      } else if (video.preload === 'none') {
        video.preload = 'metadata';
      }
    }
    document.addEventListener('mouseover', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'metadata');
    });
    document.addEventListener('touchstart', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'auto');
    }, { passive: true });
    document.addEventListener('pointerdown', function (e) {
      var tile = e.target.closest && e.target.closest('[data-mm-video-inline]');
      if (tile) warmTile(tile, 'auto');
    }, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pdp-carousel-assets"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    function initTrack(el) {
      if (el.__mmPcar) return;
      el.__mmPcar = true;
      var track = el.querySelector('[data-mm-pcar-track]');
      if (!track) return;
      var cards = track.querySelectorAll('.mm-pcar__card');
      var prev = el.querySelector('[data-mm-pcar-prev]');
      var next = el.querySelector('[data-mm-pcar-next]');
      var dotsEl = el.querySelector('[data-mm-pcar-dots]');

      var dots = [];
      if (dotsEl && cards.length > 1) {
        for (var i = 0; i < cards.length; i++) {
          var d = document.createElement('span');
          d.className = 'mm-pcar__dot';
          if (i === 0) d.setAttribute('data-active', '');
          dotsEl.appendChild(d);
          dots.push(d);
        }
      }

      function step() {
        if (!cards.length) return 0;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return cards[0].offsetWidth + gap;
      }

      function sync() {
        var max = track.scrollWidth - track.clientWidth - 1;
        if (prev) prev.disabled = track.scrollLeft <= 0;
        if (next) next.disabled = track.scrollLeft >= max;
        if (cards.length && step() > 0) {
          var idx = Math.min(cards.length - 1, Math.max(0, Math.round(track.scrollLeft / step())));
          dots.forEach(function (d, j) {
            if (j === idx) d.setAttribute('data-active', '');
            else d.removeAttribute('data-active');
          });
          cards.forEach(function (c, j) {
            c.classList.toggle('mm-pcar__card--active', j === idx);
          });
        }
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; sync(); });
      }, { passive: true });

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      // First sync waits until the track nears the viewport: its layout reads
      // (scrollWidth/offsetWidth) forced a full-page reflow at boot (PSI 314ms).
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (en) { return en.isIntersecting; })) return;
          io.disconnect();
          sync();
        }, { rootMargin: '400px 0px' });
        io.observe(track);
      } else {
        requestAnimationFrame(sync);
      }
    }

    function init(scope) {
      var root = (scope && scope.querySelectorAll) ? scope : document;
      root.querySelectorAll('[data-mm-pcar]').forEach(initTrack);
      // The peek popup shell ships with the cart drawer only when it has
      // add-on products; clone our fallback in when it's missing so the
      // cards still have a popup to open.
      if (!document.getElementById('mm-addon-peek')) {
        var tpl = document.querySelector('template[data-mm-pcar-shell]');
        if (tpl && tpl.content) document.body.appendChild(tpl.content.cloneNode(true));
      }
    }

    /* A live cart line is the only client-side source that knows app and
       automatic discounts (Kaching deals included) — once a card's variant
       is in the cart, mirror its discount-aware unit price onto the card.
       Same contract as syncAddonPricesFromCart in pdp-trimmer.js. */
    document.addEventListener('mm:cart:updated', function () {
      if (typeof CartState === 'undefined' || typeof formatMoney !== 'function') return;
      document.querySelectorAll('[data-mm-pcar-price]').forEach(function (row) {
        var vid = parseInt(row.dataset.variant, 10);
        var base = parseInt(row.dataset.base, 10) || 0;
        var line = null;
        for (var i = 0; i < CartState.items.length; i++) {
          var it = CartState.items[i];
          if (it.variant_id !== vid || it.selling_plan_allocation) continue;
          line = it;
          break;
        }
        if (!line || !line.quantity) return;
        var unit = (typeof line.final_line_price === 'number')
          ? Math.round(line.final_line_price / line.quantity)
          : line.price;
        if (!(unit > 0) || unit >= base) return;
        var now = row.querySelector('.mm-pcar__now');
        if (now) now.textContent = formatMoney(unit);
        if (!row.querySelector('.mm-pcar__was')) {
          var was = document.createElement('s');
          was.className = 'mm-pcar__was';
          was.textContent = formatMoney(base);
          row.appendChild(was);
        }
        // Keep the SAVE chip honest against the same anchor the strikethrough
        // shows: retail compare-at when there is one, base price otherwise.
        // data-save mirrors the section's "Show SAVE chip" setting.
        if (row.hasAttribute('data-save')) {
          var anchor = Math.max(parseInt(row.dataset.compare, 10) || 0, base);
          var chip = row.querySelector('.mm-pcar__save');
          if (anchor > unit) {
            if (!chip) {
              chip = document.createElement('span');
              chip.className = 'mm-pcar__save';
              row.appendChild(chip);
            }
            var amt = anchor - unit;
            if (amt >= 500) amt = Math.round(amt / 500) * 500; // round-number badge: nearest $5 step
            chip.textContent = 'SAVE ' + (typeof mmDiscountMoney === 'function' ? mmDiscountMoney(amt) : formatMoney(amt));
          }
        }
      });
    });

    /* An add from the carousel — or from the peek popup it opened — happens
       with the drawer closed, so open it and let the shopper see the line
       land. Direct card adds open same-frame (the pending row is already
       painted); popup adds wait out the popup's own 550ms "✓ Added" close
       and stay put on error so the shopper sees the Error state. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var btn = e.target.closest('[data-mm-action="quick-add"]');
      if (!btn || btn.disabled) return;
      var fromCarousel = btn.closest('[data-mm-pcar]');
      if (!fromCarousel && btn.hasAttribute('data-mm-apk-add')) {
        fromCarousel = window.AddonPeek && window.AddonPeek.card &&
          window.AddonPeek.card.closest('[data-mm-pcar]');
      }
      if (!fromCarousel || typeof openCart !== 'function') return;
      if (btn.hasAttribute('data-mm-apk-add')) {
        setTimeout(function () {
          if (!btn.hasAttribute('data-error')) openCart();
        }, 560);
      } else {
        openCart();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["policy-return-bar"] && !Shopify.designMode) return;
  try {
    (function () {
    // Both the sticky bar link and the floating mobile button.
    var links = [].slice.call(document.querySelectorAll('[data-policy-return-link]'));
    var label = document.querySelector('[data-policy-return-label]');
    if (!links.length) return;

    var ref = document.referrer || '';
    var sameOrigin = false;
    var refUrl = null;
    try {
      if (ref) {
        refUrl = new URL(ref);
        sameOrigin = refUrl.origin === window.location.origin
          && refUrl.pathname !== window.location.pathname;
      }
    } catch (e) {}

    if (sameOrigin && refUrl) {
      var href = refUrl.pathname + refUrl.search + refUrl.hash;
      links.forEach(function (l) { l.setAttribute('href', href); });

      var path = refUrl.pathname.replace(/\/+$/, '');
      var segs = path.split('/').filter(Boolean);
      var newLabel = '';

      if (segs[0] === 'products' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs[0] === 'collections' && segs[1] && segs[1] !== 'all') {
        if (segs[2] === 'products' && segs[3]) {
          newLabel = 'Return to ' + prettify(segs[3]);
        } else {
          newLabel = 'Return to ' + prettify(segs[1]);
        }
      } else if (segs[0] === 'collections') {
        newLabel = 'Return to shop';
      } else if (segs[0] === 'cart') {
        newLabel = 'Return to cart';
      } else if (segs[0] === 'blogs' && segs[2]) {
        newLabel = 'Return to ' + prettify(segs[2]);
      } else if (segs[0] === 'pages' && segs[1]) {
        newLabel = 'Return to ' + prettify(segs[1]);
      } else if (segs.length === 0) {
        newLabel = 'Return to home';
      } else {
        newLabel = 'Return to previous page';
      }

      // Only the sticky bar carries the descriptive label; the floating
      // button keeps its short static "Back".
      if (label) label.textContent = newLabel;

      links.forEach(function (l) {
        l.addEventListener('click', function (e) {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
          if (window.history.length > 1) {
            e.preventDefault();
            window.history.back();
          }
        });
      });
    }

    function prettify(slug) {
      var s = decodeURIComponent(slug).replace(/[-_]+/g, ' ').trim();
      return s.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["relay-track-link"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!/(?:^|;\s*)relay_track=[^;]+/.test(document.cookie)) return;
    document.querySelectorAll('[data-relay-track-past]').forEach(function (link) {
      link.hidden = false;
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
